import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import global_en from "./translations/en/global.json";
import global_fa from "./translations/fa/global.json";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";

i18next.init({
  interpolation: { escapeValue: false },
  lng: /^\/fa(?:\/|$)/.test(window.location.pathname) ? "fa" : "en",
  resources: { en: { global: global_en }, fa: { global: global_fa } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18next}>
    <App />
  </I18nextProvider>,
);
